import React from 'react';
import ErrorMessage from '../common/ErrorMessage';
import { useShowLoader } from '../common/showLoader';
import { ReactComponent as LiveIcon } from '../icons/icon_Live_quickNav.svg';
import { getLabel } from '../data/labels';

export default function LiveLoader(props) {
    const show = useShowLoader();

    if (props.isError) {
        return <ErrorMessage />
    }

    if (!show) {
        return null;
    }

    return (
        <>
            {props.isError ?
                <div className="xs_liveLoader container flex items-center justify-center h-full w-full">
                    <span className="text-3xl text-contrast-1">{getLabel('general.error_fetching_data')}</span>
                </div>
                :
                <div className="xs_liveLoader container flex items-center justify-center h-full w-full">
                    <LiveIcon className="animate-pulse h-48 w-48 fill-contrast-1" />
                </div>
            }
        </>
    );
}
